<template>
  <v-dialog
    v-model="show"
    hide-overlay
    persistent
    transition="dialog-bottom-transition"
    max-width="500px"
  >
    <v-card>
      <v-progress-linear
        v-show="savingData"
        indeterminate
        :color="color"
      />
      <v-card-title>
        <span
          class="headline"
        >
          {{ title }}
        </span>
      </v-card-title>
      <v-card-text
        class="pa-0"
      >
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="renewalYear"
                :error-messages="formErrors.RenewalYear"
                label="Renewal Year"
                type="number"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue darken-1"
          text
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-dialog>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import { extractFormErrors, getErrorTitle } from '@/services/ErrorHandlers'

  export default {
    name: 'RenewalDialog',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      savingData: false,
      renewalYear: null,
      formErrors: {},
      errorMessage: null,
      displayError: false,
      openEnrollmentResource: new TroodyApi('openEnrollment/'),
    }),

    computed: {
      title () {
        return this.openEnrollment ? this.openEnrollment.broker + ' / ' + this.openEnrollment.groupName : 'None'
      },

      show () {
        return this.openEnrollment !== null
      },
    },

    methods: {
      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },

      close () {
        this.formErrors = {}
        this.renewalYear = null
        this.$emit('closed')
      },

      handleError (error) {
        this.loading = false
        this.formErrors = extractFormErrors(error)
        if (this.formErrors) {
          this.showError(getErrorTitle(error), 'Failed to save!')
        } else {
          this.formErrors = {}
          this.showError(error, 'Failed to save!')
        }
      },

      save () {
        const promise = new Promise((resolve, reject) => {
          const payload = {
            id: this.openEnrollment.id,
            renewalYear: this.renewalYear ? Number(this.renewalYear) : null,
          }

          this.savingData = true

          this.openEnrollmentResource.post(payload, 'Renewal')
            .then((data) => {
              this.savingData = false
              this.openEnrollmentRecord = data
              this.openEnrollmentDirty = false
              this.$emit('renewal', data)
              resolve(data)
            })
            .catch((error) => {
              this.savingData = false
              this.handleError(error)
            })
        })

        return promise
      },
    },
  }
</script>
